module.exports = __webpack_public_path__ + "static/design01-388cf55ca5b1b0f309f8e1c1927d6bd8.png";